module.exports = __webpack_public_path__ + "img/icon_coupon_expire.e6a774c5.png";